import { EThemes } from '@/lib/contentstack-sdk/types';
import { OrMiniCtaBlockA } from './or-mini-cta-block-a';
import { parseGlobalLinkFromCMS } from '@/lib/contentstack-sdk/utils/parseHelpers';
import { RenderRichText } from '@/components/helpers/cms/RenderRichText';
import { IMiniCtaBlockAPropsCS } from './or-mini-cta-block-a.types';

export const OrMiniCtaBlockACS = ({ block }: IMiniCtaBlockAPropsCS) => {
  const {
    content_title,
    cta,
    description,
    icon: { icon },
    theme: { theme },
    title_element,
    title_variant,
    top_spacing,
    bottom_spacing,
    lead_gen_form,
  } = block;
  const ctaProps = parseGlobalLinkFromCMS(cta, 'or-mini-cta-block-a');

  return (
    <OrMiniCtaBlockA
      cta={ctaProps}
      content_title={content_title}
      theme={EThemes[theme]}
      icon={icon || null}
      title_element={title_element}
      title_variant={title_variant}
      topSpacing={top_spacing?.spacing_value}
      bottomSpacing={bottom_spacing?.spacing_value}
      topDivider={top_spacing?.divider}
      bottomDivider={bottom_spacing?.divider}
      leadGenForm={lead_gen_form?.[0]}
    >
      {description && <RenderRichText body={description} />}
    </OrMiniCtaBlockA>
  );
};
